import type { ReactNode } from "react";

/**
 * Danh muc ung dung — NGUON SU THAT DUY NHAT cho cong ung dung va sidebar.
 *
 * `href` bat dau bang '/' se di qua gateway. Moi app nghiep vu dung stack TS;
 * rieng Checklist (`migrated: false`) duoc gateway dua toi service cu.
 * `migrated` chi dung de hien thi trang thai tren cong ung dung.
 */
export interface AppEntry {
  key: string;
  name: string;
  blurb: string;
  href: string;
  /**
   * Co BAT KY quyen nao trong day la vao duoc — dung y ban Django, o do the
   * QR mo cho ca 'portal.cash_qr' LAN 'portal.cashflow'.
   */
  permissions: string[];
  /** Mot so the con mo cho staff bat ke quyen — giu nguyen nhu ban cu. */
  orStaff?: boolean;
  /**
   * The mo cho MOI nguoi da dang nhap.
   *
   * Ban Django co vai trang chi dat `login_required` ma khong gan quyen nao.
   * Gate chung bang `orStaff` se giau dung nhung nguoi can dung nhat — nhan
   * vien thuong khong phai staff.
   */
  anyUser?: boolean;
  migrated: boolean;
  tags: string[];
  icon: ReactNode;
}

const s = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  viewBox: "0 0 24 24",
} as const;

export const APPS: AppEntry[] = [
  {
    key: "cleaning",
    name: "Checklist công việc",
    blurb: "Phân công, chấm điểm và báo cáo vệ sinh theo chi nhánh.",
    href: "/cleaning/",
    permissions: ["portal.checklist"],
    migrated: false,
    tags: ["Checklist", "Khu vực", "Kết quả"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
        />
      </svg>
    ),
  },
  {
    key: "tiktok",
    name: "TMĐT",
    blurb:
      "Bán hàng, nội dung, chăm sóc khách hàng và vận hành sàn trong một nơi.",
    href: "/tmdt",
    // Co BAT KY quyen TMĐT nao. Truoc mo cho moi nguoi (anyUser) vi muc Facebook / Lich
    // livestream mo tu do — tai khoan cua hang (QLCH) cung thay. Khop TMDT_ACCESS ben API.
    permissions: [
      "portal.tmt",
      "cskh.view",
      "cskh.edit",
      "cskh.manage",
      "thht.view",
      "thht.edit",
      "thht.manage",
      // Nhan vien live: vao TMĐT nhung chi thay nhom Livestream (xem TMDT_LIVE_PERMISSIONS).
      "tiktok.live.view",
      "tiktok.live.manage",
    ],
    migrated: true,
    tags: ["Bán hàng", "Nội dung & CSKH", "Vận hành"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
  },
  {
    key: "hr",
    name: "Nhân sự & Tài khoản",
    blurb: "Nhân viên 1Office, tài khoản hệ thống và phân quyền.",
    href: "/hr",
    permissions: ["portal.hr"],
    migrated: true,
    tags: ["Nhân viên", "Tài khoản", "Phân quyền", "RBAC"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 20h5v-2a3 3 0 00-5.36-1.86M17 20H7m10 0v-2c0-.65-.12-1.28-.35-1.86M7 20H2v-2a3 3 0 015.36-1.86M7 20v-2c0-.65.12-1.28.35-1.86m0 0a5 5 0 019.3 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    ),
  },
  {
    key: "voucher",
    name: "Voucher sinh nhật",
    blurb: "Chiến dịch voucher và danh sách khách hàng đăng ký.",
    href: "/voucher",
    permissions: ["portal.voucher"],
    migrated: true,
    tags: ["Voucher", "Khách hàng"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
        />
      </svg>
    ),
  },
  {
    key: "cashflow",
    name: "Đối soát dòng tiền",
    blurb: "Giao dịch ngân hàng, doanh thu ngày và đối soát theo cửa hàng.",
    href: "/cashflow",
    permissions: ["portal.cashflow"],
    migrated: true,
    tags: ["Dòng tiền", "Đối soát", "Báo cáo tháng"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    key: "cash_qr",
    name: "QR tiền mặt cửa hàng",
    blurb: "Sinh QR động cho cửa hàng nộp tiền mặt, đối soát khoản đã thu.",
    href: "/cash-qr",
    permissions: ["portal.cash_qr", "portal.cashflow"],
    migrated: true,
    tags: ["Tiền mặt", "QR động", "Webhook"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
        />
      </svg>
    ),
  },
  {
    key: "shipping_weight",
    name: "Cân nặng vận đơn",
    blurb:
      "Chụp nhãn, đọc mã vạch và đối chiếu cân nặng với đơn vị vận chuyển.",
    href: "/can-nang",
    permissions: ["portal.shipping_weight"],
    migrated: true,
    tags: ["ĐVVC", "Cân nặng", "Mobile"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
        />
      </svg>
    ),
  },
  {
    key: "kol",
    name: "KOL / KOC Booking",
    blurb: "Chiến dịch booking, theo dõi video và chi phí theo KOC.",
    href: "/kol/chien-dich",
    permissions: ["portal.kol"],
    orStaff: true,
    migrated: true,
    tags: ["Booking", "Chiến dịch"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
        />
      </svg>
    ),
  },
  {
    key: "disbursement",
    name: "Kế hoạch giải ngân",
    blurb: "Kế hoạch vay, hoá đơn và phân bổ theo ngân hàng.",
    href: "/disbursement",
    permissions: ["portal.disbursement"],
    orStaff: true,
    migrated: true,
    tags: ["Kế hoạch vay", "Hoá đơn"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
  },
  {
    key: "nhanhvn",
    name: "Bán hàng Nhanh.vn",
    blurb: "Tồn kho, chia hàng, target doanh thu, sản xuất và phân tích.",
    // Cua vao theo quyen (ban-hang, hoac phan-tich-kh voi quyen le) — nhu
    // `app_entry` cua Django; xem pages/nhanhvn/NhanhvnEntry.tsx.
    href: "/nhanhvn",
    permissions: ["portal.nhanhvn"],
    orStaff: true,
    migrated: true,
    tags: ["Bán hàng", "MOH", "Chia hàng", "Target"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    ),
  },
  {
    key: "auditlog",
    name: "Nhật ký hoạt động",
    blurb: "Ai đã làm gì, lúc nào, trên bản ghi nào.",
    href: "/auditlog",
    permissions: ["audit.view"],
    orStaff: true,
    migrated: true,
    tags: ["Nhật ký"],
    icon: (
      <svg {...s}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
  },
];

/** Muc trong sidebar cua mot module. */
export interface ModuleNavItem {
  label: string;
  href: string;
  migrated: boolean;
  /** Bo trong nghia la muc dung chung; neu co thi chi can mot quyen khop. */
  permissions?: string[];
  /**
   * An khoi sidebar (va tim kiem / dem) nhung TRANG VAN CON: link cu, bookmark van mo
   * duoc va van xet quyen theo muc nay.
   */
  hidden?: boolean;
  icon: ReactNode;
}

/**
 * Mot nhom gap/mo duoc trong sidebar (accordion) — dung y ban Django.
 *
 * Chi tham chieu `href` cua cac muc da khai o `items`, khong khai lai item —
 * mot muc chi dinh nghia mot lan, khoi lech icon/nhan giua hai noi.
 */
export interface ModuleNavGroup {
  /** Khop `data-key` cua accordion ben Django, de doi chieu de dang. */
  key: string;
  label: string;
  hrefs: string[];
}

/**
 * Sidebar cua tung module — giu nguyen thu tu va ten muc cua ban Django,
 * de nguoi dung khong phai hoc lai vi tri.
 *
 * Checklist la muc duy nhat con tro ve service cu; cac muc con lai vao React.
 *
 * `groups` la TUY CHON: chi nhanhvn co (sidebar dai, ban Django gap thanh 5
 * nhom). Module nao khong khai `groups` thi hien danh sach phang nhu cu —
 * khong anh huong cac module con lai.
 */
export const MODULE_NAV: Record<
  string,
  { name: string; items: ModuleNavItem[]; groups?: ModuleNavGroup[] }
> = {
  tiktok: {
    name: "Quản lý sàn TMĐT",
    items: [
      {
        label: "Tổng quan",
        href: "/tiktok",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 5h6v6H4zM14 5h6v4h-6zM14 13h6v6h-6zM4 15h6v4H4z"
            />
          </svg>
        ),
      },
      {
        label: "Đánh giá",
        href: "/tiktok/reviews",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3z"
            />
          </svg>
        ),
      },
      {
        label: "Thống kê đánh giá",
        href: "/tiktok/statistics",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 19V9m5 10V5m5 14v-7m5 7V3"
            />
          </svg>
        ),
      },
      {
        label: "Theo dõi đánh giá",
        href: "/tiktok/tracking",
        migrated: true,
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 17l4-4 3 3 7-8M14 8h4v4" />
          </svg>
        ),
      },
      {
        label: "KPI đánh giá",
        href: "/tiktok/reviews/statistics/employees",
        migrated: true,
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 20v-2a4 4 0 014-4h2M9 11a4 4 0 110-8 4 4 0 010 8zm6 3h5m-2.5-2.5v5" />
          </svg>
        ),
      },
      {
        label: "Doanh thu live",
        href: "/tiktok/live/dashboard",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10l5-3v10l-5-3M4 6h11v12H4z"
            />
          </svg>
        ),
      },
      {
        label: "Phân tích live",
        href: "/tiktok/live/analysis",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 19l5-6 4 3 7-10"
            />
          </svg>
        ),
      },
      {
        label: "Lương livestream",
        href: "/tiktok/salary/report",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 7h16v12H4zM7 7V5h10v2M8 13h8"
            />
          </svg>
        ),
      },
      {
        label: "Danh mục lỗi live",
        href: "/tiktok/salary/violation-types",
        migrated: true,
        // API cua trang chi mo cho quyen luong — khong co thi an muc (route cung chan → /403).
        permissions: ["tiktok.salary.view", "tiktok.salary.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v4m0 4h.01M10.3 3.9L2.4 17.5A2 2 0 004.1 20.5h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"
            />
          </svg>
        ),
      },
      {
        label: "Đơn hàng",
        href: "/tiktok/shop/orders",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 5h2l2 10h10l3-7H6m3 11h.01M17 19h.01"
            />
          </svg>
        ),
      },
      {
        label: "Sản phẩm",
        href: "/tiktok/shop/products",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 7l8-4 8 4-8 4-8-4zm0 0v10l8 4 8-4V7M12 11v10"
            />
          </svg>
        ),
      },
      {
        label: "Sản phẩm vi phạm",
        href: "/tiktok/shop/vi-pham",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        ),
      },
      {
        label: "Doanh thu",
        href: "/tiktok/shop/revenue",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v12m3-9.5A3 3 0 0012 7c-1.7 0-3 1-3 2.3 0 3.4 6 1.4 6 4.8 0 1.3-1.3 2.3-3 2.3a3 3 0 01-3-1.5"
            />
          </svg>
        ),
      },
    ],
  },
  voucher: {
    name: "Voucher sinh nhật",
    items: [
      {
        label: "Tổng quan",
        href: "/voucher",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 5h16v14H4zM4 9h16M8 3v4m8-4v4"
            />
          </svg>
        ),
      },
      {
        label: "Chiến dịch",
        href: "/voucher/campaigns",
        migrated: true,
        // Django CampaignManageView / NhanhCampaignImportView doi voucher.manage.
        permissions: ["voucher.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7 7h.01M7 3h5l9 9-9 9-9-9V7a4 4 0 014-4z"
            />
          </svg>
        ),
      },
      {
        label: "Khách đăng ký",
        href: "/voucher/registrations",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2m7-10a4 4 0 100-8 4 4 0 000 8zm7-3h6m-3-3v6"
            />
          </svg>
        ),
      },
    ],
  },
  // Checklist cong viec (ban TS cua apps/cleaning) — cung ten muc + thu tu voi base.html Django.
  // Muc chi hien voi nguoi co quyen tuong ung (Django hien het roi chan o view).
  cleaning: {
    name: "Checklist công việc",
    items: [
      {
        label: "Tổng quan",
        href: "/cleaning/",
        migrated: true,
        permissions: ["cleaning.manager.view"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2 4 4 8-8 4 4M3 12v8a2 2 0 002 2h14a2 2 0 002-2v-8" />
          </svg>
        ),
      },
      {
        label: "Báo cáo theo ngày",
        href: "/cleaning/report/",
        migrated: true,
        permissions: ["cleaning.manager.view"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        ),
      },
      {
        label: "Bảng điểm",
        href: "/cleaning/score/",
        migrated: true,
        permissions: ["cleaning.manager.view"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2" />
          </svg>
        ),
      },
      {
        label: "Báo cáo tổng hợp",
        href: "/cleaning/cross-report/",
        migrated: true,
        permissions: ["cleaning.manager.view"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
          </svg>
        ),
      },
      {
        label: "Lịch nhân viên trống",
        href: "/cleaning/schedule-empty-report/",
        migrated: true,
        permissions: ["cleaning.manager.view"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
      },
      {
        label: "Chi nhánh & Khu vực",
        href: "/cleaning/branches/",
        migrated: true,
        permissions: ["cleaning.admin"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0H5m14 0h2m-16 0h2m4-7h6m-6 4h6m-6-8h6" />
          </svg>
        ),
      },
      {
        label: "Quản lý chi nhánh",
        href: "/cleaning/branch-managers/",
        migrated: true,
        permissions: ["cleaning.manager.edit"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.36-1.86M17 20H7m10 0v-2c0-.65-.13-1.28-.36-1.86M7 20H2v-2a3 3 0 015.36-1.86M7 20v-2c0-.65.13-1.28.36-1.86m0 0a5 5 0 019.29 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        ),
      },
      {
        label: "Xếp lịch thủ công",
        href: "/cleaning/schedule/",
        migrated: true,
        permissions: ["cleaning.schedule"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2" />
          </svg>
        ),
      },
      {
        label: "Cấu hình Lark",
        href: "/cleaning/lark-mapping/",
        migrated: true,
        permissions: ["cleaning.admin"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
          </svg>
        ),
      },
      {
        label: "Trang nhân viên",
        href: "/cleaning/worker/",
        migrated: true,
        permissions: ["cleaning.worker"],
        icon: (
          <svg {...s}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        ),
      },
    ],
  },
  shipping_weight: {
    name: "Cân nặng vận đơn",
    items: [
      {
        label: "Ghi phiếu cân",
        href: "/can-nang",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 7h16M6 7l2-3h8l2 3m-12 0v13h12V7M9 12h6"
            />
          </svg>
        ),
      },
      {
        label: "Báo cáo",
        href: "/can-nang/bao-cao",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 19V9m5 10V5m5 14v-7m5 7V3"
            />
          </svg>
        ),
      },
    ],
  },
  kol: {
    name: "KOL / KOC Booking",
    items: [
      {
        label: "Tổng quan",
        href: "/kol/bao-cao/tong-quan",
        migrated: true,
        icon: (
          <svg {...s}>
            <rect x="3" y="3" width="7" height="7" rx="1.5" />
            <rect x="14" y="3" width="7" height="7" rx="1.5" />
            <rect x="3" y="14" width="7" height="7" rx="1.5" />
            <rect x="14" y="14" width="7" height="7" rx="1.5" />
          </svg>
        ),
      },
      {
        label: "Danh sách KOC",
        // Bookmark Django /kol/koc duoc App.tsx chuyen ve duong React nay.
        href: "/kol/danh-sach-koc",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
      {
        label: "Chiến dịch",
        href: "/kol/chien-dich",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Hiệu quả từng đợt",
        href: "/kol/bao-cao/hieu-qua-dot",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 19V9m5 10V5m5 14v-7m5 7V3"
            />
          </svg>
        ),
      },
      {
        label: "Đánh giá theo tỉnh thành",
        href: "/kol/bao-cao/tinh-thanh",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 21s-7-6.2-7-11.5A7 7 0 0112 2.5a7 7 0 017 7C19 14.8 12 21 12 21zm0-8.5a3 3 0 100-6 3 3 0 000 6z"
            />
          </svg>
        ),
      },
      {
        label: "Kế hoạch ngân sách KOC",
        href: "/kol/bao-cao/ke-hoach-ngan-sach",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 6h18M3 12h18M3 18h11m4-2v4m-2-2h4"
            />
          </svg>
        ),
      },
      {
        label: "Hiệu suất KOC",
        href: "/kol/bao-cao/koc",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        ),
      },
      {
        label: "KOC theo ngày",
        href: "/kol/bao-cao/koc-theo-ngay",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Đăng muộn",
        href: "/kol/bao-cao/dang-muon",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Chi phí theo tỉnh",
        href: "/kol/bao-cao/chi-phi",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Hiệu suất video",
        href: "/kol/bao-cao/video",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Tất cả video",
        href: "/kol/bao-cao/tat-ca-video",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Tổng hợp theo tỉnh",
        href: "/kol/bao-cao/tong-hop-tinh",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 17v-6m4 6V7m4 10v-3M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        ),
      },
    ],
  },
  thht: {
    name: "Trả hàng hoàn tiền",
    items: [
      {
        label: "Tổng quan",
        href: "/thht",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 5a1 1 0 011-1h4a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 17a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2zM14 5a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM14 13a1 1 0 011-1h4a1 1 0 011 1v6a1 1 0 01-1 1h-4a1 1 0 01-1-1v-6z"
            />
          </svg>
        ),
      },
      {
        label: "Danh sách yêu cầu",
        href: "/thht/list",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
        ),
      },
      {
        label: "Báo cáo",
        href: "/thht/report",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        ),
      },
    ],
  },
  cskh: {
    name: "Chăm sóc khách hàng",
    items: [
      {
        label: "Thống kê Pancake",
        href: "/cskh",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        ),
      },
      {
        label: "Bảng lương KPI",
        href: "/cskh/kpi",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 7h6m-6 4h6m-6 4h4M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Lịch trực",
        href: "/cskh/lich-truc",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Hội thoại",
        href: "/cskh/hoi-thoai",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 10h8M8 14h5m8-2a9 9 0 11-4-7.5L21 3v9z"
            />
          </svg>
        ),
      },
      {
        label: "Cấu hình & vi phạm",
        href: "/cskh/quan-ly",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4"
            />
          </svg>
        ),
      },
    ],
  },
  facebook: {
    name: "Facebook",
    items: [
      {
        label: "Bài viết trang",
        href: "/facebook",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        ),
      },
    ],
  },
  shifts: {
    name: "Lịch ca live",
    items: [
      {
        label: "Đăng ký ca live",
        href: "/shifts",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
    ],
  },
  hr: {
    name: "Nhân sự",
    items: [
      {
        label: "Nhân viên 1Office",
        href: "/hr",
        migrated: true,
        permissions: ["hr.view", "hr.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 20h5v-2a3 3 0 00-5.36-1.86M17 20H7m10 0v-2c0-.65-.12-1.28-.35-1.86M7 20H2v-2a3 3 0 015.36-1.86M7 20v-2c0-.65.12-1.28.35-1.86m0 0a5 5 0 019.3 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
      {
        label: "Tài khoản hệ thống",
        href: "/hr/accounts",
        migrated: true,
        permissions: ["hr.view", "hr.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        ),
      },
      // Phan quyen nam TRONG module Nhan su, dung nhu ban cu — o do the
      // "Nhan su & Tai khoan" mang ca hai the "Phan quyen" va "RBAC".
      {
        label: "Phân quyền · Người dùng",
        href: "/rbac/users",
        migrated: true,
        permissions: ["rbac.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
            />
          </svg>
        ),
      },
      {
        label: "Phân quyền · Vai trò",
        href: "/rbac/roles",
        migrated: true,
        permissions: ["rbac.manage"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        ),
      },
    ],
  },

  auditlog: {
    name: "Nhật ký hoạt động",
    items: [
      {
        label: "Nhật ký",
        href: "/auditlog",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        ),
      },
    ],
  },

  cash_qr: {
    name: "QR tiền mặt cửa hàng",
    items: [
      {
        label: "QR chuyển về mẹ",
        href: "/cash-qr",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
            />
          </svg>
        ),
      },
      {
        label: "Đối soát đã thu",
        href: "/cash-qr/deposits",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Cấu hình TK mẹ",
        href: "/cash-qr/mapping",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
    ],
  },

  nhanhvn: {
    name: "Bán hàng Nhanh.vn",
    items: [
      {
        label: "Bán lẻ theo kho",
        href: "/nhanhvn/ban-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 3v18h18M7 14l4-4 3 3 5-6"
            />
          </svg>
        ),
      },
      {
        label: "Đơn hàng theo kho",
        href: "/nhanhvn/don-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        ),
      },
      {
        label: "Bán lẻ theo tháng",
        href: "/nhanhvn/theo-thang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Chi tiết sản phẩm",
        href: "/nhanhvn/chi-tiet-sp",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 10h16M4 14h10M4 18h10"
            />
          </svg>
        ),
      },
      {
        label: "Danh sách bill",
        href: "/nhanhvn/danh-sach-bill",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        ),
      },
      {
        label: "Cấu hình sản phẩm",
        href: "/nhanhvn/cau-hinh-sp",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
      {
        label: "MOH / Tồn kho",
        href: "/nhanhvn/moh",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
        ),
      },
      {
        label: "MOH theo giá trị",
        href: "/nhanhvn/moh-gia-tri",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Bán chạy / bán chậm",
        href: "/nhanhvn/ban-chay",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            />
          </svg>
        ),
      },
      {
        label: "Phân tích sản phẩm",
        href: "/nhanhvn/phan-tich-sp",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
        ),
      },
      {
        label: "Phân tích khách hàng",
        href: "/nhanhvn/phan-tich-kh",
        migrated: true,
        permissions: ["nhanhvn.view", "nhanhvn.view_customer_analytics"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 20h5v-2a3 3 0 00-5.36-1.86M17 20H7m10 0v-2c0-.65-.12-1.28-.35-1.86M7 20H2v-2a3 3 0 015.36-1.86M7 20v-2c0-.65.12-1.28.35-1.86m0 0a5 5 0 019.3 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
      {
        label: "Tái mã sản phẩm",
        href: "/nhanhvn/tai-ma",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        ),
      },
      {
        label: "Ngày bán đầu tiên",
        href: "/nhanhvn/ngay-ban-dau-tien",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
      },
      {
        label: "Bù hàng",
        href: "/nhanhvn/bu-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
        ),
      },
      {
        label: "Chia hàng Shopee (tốc độ bán)",
        href: "/nhanhvn/chia-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
            />
          </svg>
        ),
      },
      {
        label: "Chia hàng Shopee (tỉ lệ DT)",
        href: "/nhanhvn/chia-hang-dt",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 3v18h18M7 14l4-4 4 4 5-6"
            />
          </svg>
        ),
      },
      {
        label: "Chia hàng nhập kho mới",
        href: "/nhanhvn/chia-hang-nhap",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        ),
      },
      {
        label: "Kế hoạch điều phối hàng",
        href: "/nhanhvn/ke-hoach-hang-hoa/dieu-phoi",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h10m-10 6h6m8-4l3 3-3 3m3-3h-7"
            />
          </svg>
        ),
      },
      {
        label: "Phiếu nhập kho NCC",
        href: "/nhanhvn/phieu-nhap",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        ),
      },
      {
        label: "Chia hàng Kho MT",
        href: "/nhanhvn/chia-kho-mt",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 7l9-4 9 4-9 4-9-4zm0 5l9 4 9-4M3 17l9 4 9-4"
            />
          </svg>
        ),
      },
      {
        label: "Chia hàng Kho cửa hàng",
        href: "/nhanhvn/chia-kho-cua-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 21h18M5 21V9l7-6 7 6v12M9 21v-6h6v6"
            />
          </svg>
        ),
      },
      {
        label: "Theo dõi sản xuất (Lark)",
        href: "/nhanhvn/theo-doi-sx",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        ),
      },
      {
        label: "Đặt hàng Trung Quốc",
        href: "/nhanhvn/dat-hang-tq",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            />
          </svg>
        ),
      },
      {
        label: "Target doanh thu",
        href: "/nhanhvn/target-v3",
        migrated: true,
        // An 26/10/2026: Kế hoạch hàng hoá da du thong tin.
        hidden: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zM5 12h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            />
          </svg>
        ),
      },
      {
        label: "Target theo danh mục",
        href: "/nhanhvn/target-danh-muc",
        migrated: true,
        // An 26/10/2026: Kế hoạch hàng hoá da du thong tin.
        hidden: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            />
          </svg>
        ),
      },
      {
        label: "SL sản xuất chi tiết",
        href: "/nhanhvn/san-luong-sx",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
        ),
      },
      {
        // Mot trang nhieu tab (nhu ban demo); cac muc ben duoi tro thang toi tung tab (tim duoc
        // o "Tìm chức năng") nhung khong nam trong nhom menu.
        label: "Kế hoạch hàng hoá",
        href: "/nhanhvn/ke-hoach-hang-hoa",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13h4v7H3v-7zm7-6h4v13h-4V7zm7-4h4v17h-4V3z"
            />
          </svg>
        ),
      },
      {
        label: "Tổng quan kế hoạch hàng hoá",
        href: "/nhanhvn/ke-hoach-hang-hoa/tong-quan",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13h4v7H3v-7zm7-6h4v13h-4V7zm7-4h4v17h-4V3z"
            />
          </svg>
        ),
      },
      {
        label: "Tỉ trọng danh mục theo vùng",
        href: "/nhanhvn/ke-hoach-hang-hoa/target-doanh-thu#sec-vm",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055zM20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
            />
          </svg>
        ),
      },
      {
        label: "Bộ sản phẩm khai trương",
        href: "/nhanhvn/ke-hoach-hang-hoa/bo-khai-truong",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
        ),
      },
      {
        label: "Kế hoạch nhập theo mã con",
        href: "/nhanhvn/ke-hoach-hang-hoa/nhap-hang",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3M4 11h16M5 5h14a1 1 0 011 1v13a2 2 0 01-2 2H6a2 2 0 01-2-2V6a1 1 0 011-1zm7 9v4m-2-2h4"
            />
          </svg>
        ),
      },
      {
        label: "Đang sản xuất / đang về",
        href: "/nhanhvn/ke-hoach-hang-hoa/dang-ve",
        migrated: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 17a2 2 0 11-4 0 2 2 0 014 0zm10 0a2 2 0 11-4 0 2 2 0 014 0zM13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1"
            />
          </svg>
        ),
      },
      {
        label: "Dashboard hàng hoá",
        href: "/nhanhvn/dashboard-hang-hoa",
        migrated: true,
        // An 26/10/2026: Kế hoạch hàng hoá da du thong tin.
        hidden: true,
        permissions: ["nhanhvn.view"],
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2"
            />
          </svg>
        ),
      },
    ],
    // Nhom gap/mo theo KEY + THU TU ban Django (apps/nhanhvn/templates/nhanhvn/base.html).
    // Nhom "Target" + "Dashboard hàng hoá" an 26/10/2026: Kế hoạch hàng hoá da du thong tin.
    // "y% kho ổn định" va "Re-target" (target theo mua vu cu) da go han 02/10/2026,
    // giong ban Django — chi con Target v3.
    groups: [
      {
        key: "bao-cao",
        label: "Báo cáo",
        hrefs: [
          "/nhanhvn/moh",
          "/nhanhvn/moh-gia-tri",
          "/nhanhvn/ban-chay",
          "/nhanhvn/phan-tich-sp",
          "/nhanhvn/phan-tich-kh",
        ],
      },
      // Ke hoach hang hoa: MOT trang nhieu tab (nhu ban demo) — bam tab doi noi dung tai cho.
      {
        key: "ke-hoach",
        label: "Kế hoạch hàng hoá",
        hrefs: ["/nhanhvn/ke-hoach-hang-hoa"],
      },
      {
        key: "ton-kho",
        label: "Tồn kho & chia hàng",
        hrefs: [
          "/nhanhvn/chia-hang",
          "/nhanhvn/chia-hang-dt",
          "/nhanhvn/chia-hang-nhap",
          "/nhanhvn/chia-kho-mt",
          "/nhanhvn/chia-kho-cua-hang",
          "/nhanhvn/phieu-nhap",
          "/nhanhvn/san-luong-sx",
          "/nhanhvn/bu-hang",
          "/nhanhvn/theo-doi-sx",
          "/nhanhvn/dat-hang-tq",
        ],
      },
      {
        key: "san-pham",
        label: "Sản phẩm",
        hrefs: [
          "/nhanhvn/chi-tiet-sp",
          "/nhanhvn/cau-hinh-sp",
          "/nhanhvn/tai-ma",
          "/nhanhvn/ngay-ban-dau-tien",
        ],
      },
      {
        key: "ban-hang",
        label: "Bán hàng",
        hrefs: [
          "/nhanhvn/ban-hang",
          "/nhanhvn/don-hang",
          "/nhanhvn/theo-thang",
          "/nhanhvn/danh-sach-bill",
        ],
      },
    ],
  },

  disbursement: {
    name: "Kế hoạch giải ngân",
    items: [
      {
        label: "Khoản vay",
        href: "/disbursement",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        ),
      },
      {
        label: "Lịch trả lãi",
        href: "/disbursement/periods",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Ngày chốt lãi",
        href: "/disbursement/bank-config",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        ),
      },
    ],
  },
  cashflow: {
    name: "Đối soát dòng tiền",
    items: [
      {
        label: "Giao dịch",
        href: "/cashflow",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2"
            />
          </svg>
        ),
      },
      {
        label: "Lịch sử ngân hàng",
        href: "/cashflow/bank-history",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 10h18M3 6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6z"
            />
          </svg>
        ),
      },
      {
        label: "Doanh thu theo ngày",
        href: "/cashflow/revenue",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        ),
      },
      {
        label: "Báo cáo tháng",
        href: "/cashflow/monthly",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2"
            />
          </svg>
        ),
      },
      {
        label: "Doanh thu cửa hàng",
        href: "/cashflow/revenue/store",
        migrated: true,
        icon: (
          <svg {...s}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0H5m14 0h2m-16 0h2m4-7h6m-6 4h6m-6-8h6"
            />
          </svg>
        ),
      },
    ],
  },
};

/*
 * Ban cu dat ba khu vuc nay trong cung app TMĐT. Giu lai cac khai bao rieng
 * o tren de bookmark va route cu van hoat dong, nhung giao dien moi dung mot
 * sidebar chung va loc tung muc theo quyen cua tai khoan.
 */
/**
 * San TikTok (tong quan, danh gia, shop, vi pham) — KHONG gom quyen livestream: nhan vien live
 * khong thay. Khop TIKTOK_PLATFORM_ACCESS ben API.
 */
const TMDT_SHOP_PERMISSIONS = ["portal.tmt", "tiktok.reviews.view", "tiktok.reviews.edit"];
/** Livestream (dashboard, phan tich, luong cua minh). Khop TIKTOK_LIVE_ACCESS ben API. */
const TMDT_LIVE_PERMISSIONS = [
  "portal.tmt",
  "tiktok.live.view",
  "tiktok.live.manage",
  "tiktok.salary.view",
  "tiktok.salary.manage",
];
const TMDT_CSKH_PERMISSIONS = ["cskh.view", "cskh.edit", "cskh.manage"];
const TMDT_THHT_PERMISSIONS = ["thht.view", "thht.edit", "thht.manage"];

/** Gan quyen cua khu vuc; muc da khai quyen RIENG (chat hon) thi giu nguyen. */
const withPermissions = (
  items: ModuleNavItem[],
  permissions: string[],
): ModuleNavItem[] =>
  items.map((item) => ({
    ...item,
    permissions: item.permissions?.length ? item.permissions : permissions,
  }));

const tmdtHome: ModuleNavItem = {
  label: "Tổng quan TMĐT",
  href: "/tmdt",
  migrated: true,
  icon: (
    <svg {...s}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 5h6v6H4zM14 5h6v4h-6zM14 13h6v6h-6zM4 15h6v4H4z"
      />
    </svg>
  ),
};

/** Muc livestream cua TikTok — tach khoi "Sàn TMĐT" thanh nhom rieng, chung voi lich ca. */
const TMDT_LIVE_HREFS = new Set([
  "/tiktok/live/dashboard",
  "/tiktok/live/analysis",
  "/tiktok/salary/report",
  "/tiktok/salary/violation-types",
]);

const tmdtPlatformItems = MODULE_NAV.tiktok!.items.flatMap((item) =>
  withPermissions([item], TMDT_LIVE_HREFS.has(item.href) ? TMDT_LIVE_PERMISSIONS : TMDT_SHOP_PERMISSIONS),
);
const tmdtCskhItems = withPermissions(
  MODULE_NAV.cskh!.items,
  TMDT_CSKH_PERMISSIONS,
);
const tmdtThhtItems = withPermissions(
  MODULE_NAV.thht!.items,
  TMDT_THHT_PERMISSIONS,
);
/** Co BAT KY quyen TMĐT nao (tru nhan vien live) — Facebook khong co quyen rieng. Khop TMDT_ACCESS ben API. */
const TMDT_ACCESS_PERMISSIONS = [
  ...TMDT_SHOP_PERMISSIONS,
  ...TMDT_CSKH_PERMISSIONS,
  ...TMDT_THHT_PERMISSIONS,
];
const tmdtFacebookItems = withPermissions(
  MODULE_NAV.facebook!.items,
  TMDT_ACCESS_PERMISSIONS,
);
/** Dang ky ca live: them nhan vien live (API shifts cung mo cho tiktok.live.*). */
const tmdtShiftItems = withPermissions(MODULE_NAV.shifts!.items, [
  ...TMDT_ACCESS_PERMISSIONS,
  "tiktok.live.view",
  "tiktok.live.manage",
]);

MODULE_NAV.tmdt = {
  name: "TMĐT",
  items: [
    tmdtHome,
    ...tmdtPlatformItems,
    ...tmdtCskhItems,
    ...tmdtThhtItems,
    ...tmdtFacebookItems,
    ...tmdtShiftItems,
  ],
  groups: [
    {
      key: "platform",
      label: "Sàn TMĐT",
      hrefs: [
        tmdtHome.href,
        ...tmdtPlatformItems
          .map((item) => item.href)
          .filter((href) => !TMDT_LIVE_HREFS.has(href)),
      ],
    },
    {
      key: "livestream",
      label: "Livestream",
      hrefs: [
        ...tmdtPlatformItems
          .map((item) => item.href)
          .filter((href) => TMDT_LIVE_HREFS.has(href)),
        ...tmdtShiftItems.map((item) => item.href),
      ],
    },
    {
      key: "customer-care",
      label: "Chăm sóc khách hàng",
      hrefs: tmdtCskhItems.map((item) => item.href),
    },
    {
      key: "returns-refunds",
      label: "Trả hàng & hoàn tiền",
      hrefs: tmdtThhtItems.map((item) => item.href),
    },
    {
      key: "facebook-content",
      label: "Nội dung Facebook",
      hrefs: tmdtFacebookItems.map((item) => item.href),
    },
  ],
};
